module.exports = __webpack_public_path__ + "static/19import-56e31dd5a6f8c7320f801babd838eec5.png";